/*
 * @Descripttion: 咸亨公告详情页reducer
 * @Author: 曹博
 * @Date: 2023-10-16 14:59:26
 * @LastEditors: 曹博
 * @LastEditTime: 2023-10-16 15:02:28
 */
import { ReturnDetail } from '../../api/AnnouncementApi'
import { ActionType, CustomAction } from '../../global'

interface State {
  dataSource: any
  attachmentList: any
  isPreviewModalVisible: boolean
  previewFileUrl: string
}

export const initState: State = {
  dataSource: {},
  attachmentList: [],
  isPreviewModalVisible: false,
  previewFileUrl: '',
}

type Action = ActionType<State>

export default function reducer(
  state: State,
  action: CustomAction<Action>,
): State {
  let newstate = { ...state }
  switch (action.type) {
    case 'setDataSourceAction':
      newstate.dataSource = action.payload
      return newstate
    case 'setAttachmentListAction':
      newstate.attachmentList = action.payload
      return newstate
    case 'setIsPreviewModalVisibleAction':
      newstate.isPreviewModalVisible = action.payload
      return newstate
    case 'setPreviewFileUrlAction':
      newstate.previewFileUrl = action.payload
      return newstate
    case 'reloadStateAction':
      newstate = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

/**
 * 设置表格数据
 * @param param
 * @returns
 */
export const setDataSourceAction = (
  param: ReturnDetail,
): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: param,
})

// 重载数据
export const reloadStateAction = (param: State): CustomAction<Action> => ({
  type: 'reloadStateAction',
  payload: param,
})

// 设置公告附件
export const setAttachmentListAction = (param: any): CustomAction<Action> => ({
  type: 'setAttachmentListAction',
  payload: param,
})

// 预览弹窗
export const setIsPreviewModalVisibleAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setIsPreviewModalVisibleAction',
  payload: val,
})

// 预览文件url
export const setPreviewFileUrlAction = (val: string): CustomAction<Action> => ({
  type: 'setPreviewFileUrlAction',
  payload: val,
})
/*
 * @Descripttion: 咸亨公告详情页reducer
 * @Author: 曹博
 * @Date: 2023-10-16 14:59:26
 * @LastEditors: 曹博
 * @LastEditTime: 2023-10-16 15:02:28
 */
import { ReturnDetail } from '../../api/AnnouncementApi'
import { ActionType, CustomAction } from '../../global'

interface State {
  dataSource: any
  attachmentList: any
  isPreviewModalVisible: boolean
  previewFileUrl: string
}

export const initState: State = {
  dataSource: {},
  attachmentList: [],
  isPreviewModalVisible: false,
  previewFileUrl: '',
}

type Action = ActionType<State>

export default function reducer(
  state: State,
  action: CustomAction<Action>,
): State {
  let newstate = { ...state }
  switch (action.type) {
    case 'setDataSourceAction':
      newstate.dataSource = action.payload
      return newstate
    case 'setAttachmentListAction':
      newstate.attachmentList = action.payload
      return newstate
    case 'setIsPreviewModalVisibleAction':
      newstate.isPreviewModalVisible = action.payload
      return newstate
    case 'setPreviewFileUrlAction':
      newstate.previewFileUrl = action.payload
      return newstate
    case 'reloadStateAction':
      newstate = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

/**
 * 设置表格数据
 * @param param
 * @returns
 */
export const setDataSourceAction = (
  param: ReturnDetail,
): CustomAction<Action> => ({
  type: 'setDataSourceAction',
  payload: param,
})

// 重载数据
export const reloadStateAction = (param: State): CustomAction<Action> => ({
  type: 'reloadStateAction',
  payload: param,
})

// 设置公告附件
export const setAttachmentListAction = (param: any): CustomAction<Action> => ({
  type: 'setAttachmentListAction',
  payload: param,
})

// 预览弹窗
export const setIsPreviewModalVisibleAction = (
  val: boolean,
): CustomAction<Action> => ({
  type: 'setIsPreviewModalVisibleAction',
  payload: val,
})

// 预览文件url
export const setPreviewFileUrlAction = (val: string): CustomAction<Action> => ({
  type: 'setPreviewFileUrlAction',
  payload: val,
})
